import React from 'react';
import PropTypes from 'prop-types';

const UserInformation = ({ name, sub, onMenuClick }) => {
  return (
    <div
      className="no-print"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '100%',
        marginRight: '30px'
      }}
    >
      <div className="user">
        <div className="name">{name || ' '}</div>
        {sub && <div className="company">({sub})</div>}
      </div>
      <div
        className="icon-arrow-down5 text-24 cursor-pointer"
        onClick={onMenuClick}
        style={{ marginLeft: '10px' }}
      />
    </div>
  );
};

UserInformation.propTypes = {
  name: PropTypes.string,
  sub: PropTypes.string
};

export default UserInformation;



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Header/UserInformation.js